import React, { useState } from "react";
import { createPortal } from "react-dom";

/**
 * @typedef {import("react").ForwardedRef<HTMLIFrameElement>} ForwardedRef
 * @typedef {import("react").ReactNode} ReactNode
 * @typedef {import("react").CSSProperties} CSSProperties
 *
 * @typedef {Object} MountFrameProps
 * @prop {Object=} style
 * @prop {string=} id
 * @prop {boolean=} useTemplateDoc
 * @prop {ReactNode} children
 * @prop {CSSProperties=} mountStyle
 */

const MountFrame = React.forwardRef(
  /**
   * Mount
   * @param {MountFrameProps} props
   * @param {ForwardedRef} ref
   
   * @returns
   */
  ({ style, id, useTemplateDoc = true, children, mountStyle }, ref) => {
    const [mount, setMount] = useState(
      /**@type {HTMLIFrameElement=} */ (undefined),
    );
    /** @param {HTMLIFrameElement | *} frame */
    const setRefs = (frame) => {
      if (frame && !frame._mountInit && useTemplateDoc) {
        frame.contentDocument.write(
          "<!DOCTYPE html><html><head></head><body></body></html>",
        );
        frame._mountInit = true;
      }
      setMount(frame);
      ref && ref(frame);
    };
    const frameProps = {
      style,
      frameBorder: 0,
      scrolling: "no",
      id,
      pointerEvents: "auto",
    };

    const styles = { ...mountStyle };

    const renderFrameContents = () =>
      mount?.contentWindow?.document?.body
        ? createPortal(
            <div id="render-mount" style={styles}>
              {children}
            </div>,
            mount?.contentWindow?.document?.body,
          )
        : null;

    return (
      <iframe {...frameProps} ref={setRefs}>
        {mount?.contentWindow?.document?.body && renderFrameContents()}
      </iframe>
    );
  },
);

export default MountFrame;
